<template>
  <div>
    <v-tabs-items 
      id="contentTypeCalendar" 
      v-model="tab" 
      class="no-scroll" 
      style="overflow-y: scroll;"
      :class="{ 'transparent' : isRepriseTab }"
      :style="isRepriseTab ? '' : 'max-height: calc(100vh - 377px);'"
      @change="changeTab"
    >
      <v-tab-item
        v-for="tabItem in tabs"
        :key="`tab_content_${tabItem.tabKey}`"
        :value="`${tabItem.tabKey}`"
      >
        <ContentTypeCalendar :tab-key="tabItem.tabKey" />
      </v-tab-item>
    </v-tabs-items>
    <div v-if="tabs.length > 1" class="z2 absolute bottom-0 full-width" :style="isRepriseTab ? '' : 'height: 96px;'">
      <v-tabs
        v-model="tab"
        background-color="white"
        centered
        dark
        icons-and-text
        class="sticky bottom-0 z1 full-height"
        @change="changeTab"
      >
        <v-tabs-slider color="red" />

        <div
          v-for="tabItem in tabs"
          :key="`tab_switcher_${tabItem.tabKey}`"
        >
          <v-tab :href="`#${tabItem.tabKey}`" :class="`${tab === tabItem.tabKey ? 'red--text' : 'grey--text'}`">
            {{ tabItem.label }}
            <v-icon v-if="tabItem.icon" :class="[{'third--text': tab === tabItem.tabKey},'grey--text']">{{ tabItem.icon }}</v-icon>
          </v-tab>
        </div>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import ContentTypeCalendar from './contentType/ContentTypeCalendar.vue';

import store from '@/store';

export default {
  components: { ContentTypeCalendar },
  setup () {
    const tab = ref(store.state.currentTab);

    const allowedTabs = ref([
      { tabKey: 'reprise', icon: '$reprise-tab-icon', label: 'Reprises', show: true },
      { tabKey: 'place', icon: 'mdi-map-marker', label: 'Lieux de pratiques', show: true },
      { tabKey: 'instructor', icon: 'mdi-account-multiple', label: 'Moniteurs', show: true },
      { tabKey: 'horse', icon: 'mdi-horse', label: 'Chevaux', show: true },
      { tabKey: 'customer', icon: 'mdi-account', label: 'Cavaliers', show: true }
    ]);

    // tabs
    const tabs = computed(() => {
      if (store?.state?.siteInfo?.pegaseSettings?.tabs?.length) {
        return allowedTabs.value.filter(item => store.state.siteInfo.pegaseSettings.tabs.includes(item.tabKey) && item.show);
      }
      return allowedTabs.value.filter(item => item.show);
    });

    const isRepriseTab = computed(() => store.state.currentTab === 'reprise');

    const changeTab = value => {
      const quantity = 2;
      document.getElementById('mainPlanner').scrollLeft = 0;
      if (['horse', 'customer'].includes(tab)) {
        for (let i = 0; i < quantity; i += 1) {
          const hourDiv = document.getElementById(`hourList-${store.state.currentTab}-${i}`);
          if (hourDiv) {
            document.getElementById(`hourList-${store.state.currentTab}-${i}`).scrollLeft = 0;
          }
          const contentDiv = document.getElementById(`contentTypePlanner-${store.state.currentTab}-${i}`);
          if (contentDiv) {
            document.getElementById(`contentTypePlanner-${store.state.currentTab}-${i}`).scrollLeft = 0;
          }
        }
        return;
      }

      const hourDiv = document.getElementById(`hourList-${store.state.currentTab}`);
      const contentDiv = document.getElementById(`contentTypePlanner-${store.state.currentTab}`);
      if (hourDiv) {
        document.getElementById(`hourList-${store.state.currentTab}`).scrollLeft = 0;
      }

      if (contentDiv) {
        document.getElementById(`contentTypePlanner-${store.state.currentTab}`).scrollLeft = 0;
      }

      store.commit('setCurrentTab', value);
      store.commit('setFilters', null);
      store.commit('setFilterType', null);
      store.commit('setSearch', null);
      const sideBardFilters = { session: { product_activity: {}, discipline: {} }, Absence: false, horse: { session: { type: [] } }, instructor: { session: { type: [] } }, customer: {} };
      store.commit('setSideBarFilters', sideBardFilters);
    };

    return { tab, tabs, changeTab, isRepriseTab };
  }
};
</script>

<style>
  /* content type tabs header*/
  .v-tabs--icons-and-text > .v-tabs-bar{
    height: 100%;
  }

  .v-tab {
  height: 85px;}
</style>
